import { Spinner, VStack } from "@chakra-ui/react";
import React from "react";

export default function ComponentSpinner(props: any) {
  return (
    <VStack
      {...props}
      minH={props.minH || "200px"}
      w={"100%"}
      justify={"center"}
      flex={1}
    >
      <Spinner />
    </VStack>
  );
}
